export default [
    {
        to: "/app", layout: "/sidebar", children: [
            {to: "/app/dashboard", text: "首页", component: "dashboard"},
            {to: "/app/dashboard/remit", text: "首页", component: "dashboard/remit"},
            {to: "/app/:product/message/task", component: 'message/list'},
            {to: "/app/detection/:category", component: 'detection'},
            {to: "/app/finance/recharge/:type", text: "充值管理", component : "finance/recharge", entry: "backend"},
            {to: "/app/finance/consume/customer", text: "消耗管理", component : "finance/consume", entry: "backend"},

            {to: "/app/notice", component: "notice"},
        ]
    },
    {to: "/login", component: "login", text: "客户登陆"},
    {to: "/register", component: "register", text: "客户注册"}
]
